
  document.addEventListener("DOMContentLoaded", function () {
    const allImgs = document.querySelectorAll('img');

    allImgs.forEach(img => {
      // Remove width from src
      let src = img.getAttribute('src');
      if (src) {
        src = src.replace(/[\?&]width=\d+/g, '');
        img.setAttribute('src', src);
      }

      // Remove width values from srcset and keep original URLs
      const srcset = img.getAttribute('srcset');
      if (srcset) {
        const sources = srcset.split(',').map(s => {
          let [url, size] = s.trim().split(' ');
          url = url.replace(/[\?&]width=\d+/g, '');
          return `${url} ${size || ''}`.trim();
        });
        img.setAttribute('srcset', sources.join(', '));
      }

      // Set sizes to 100vw to allow full image rendering responsively
      img.setAttribute('sizes', '100vw');
    });
  });
